import { accountingReportsModules } from "../../../constants";

export function getData(displayModules, title) {
  if (title === "Reports") {
    return [
      {
        id: title.toLowerCase(),
        text: title,
        state: "checked",
        // checked: true,
        firstparent: title.toLowerCase(),
        parent: true,
        children: [
          {
            id: "accounting-reports",
            text: "Accounting Reports",
            state: "closed",
            parent: true,
            children: getSecondLevelData(
              accountingReportsModules,
              title.toLowerCase()
            ),
          },
        ],
      },
    ];
  } else {
    return [
      {
        id: title.toLowerCase(),
        text: title,
        // state: "closed",
        // closed: false,
        firstparent: title.toLowerCase(),
        parent: true,
        children: getSecondLevelData(displayModules, title.toLowerCase()),
      },
    ];
  }
}

function getSecondLevelData(displayModules, parent) {
  //console.log("displayModules",displayModules)
  var finalData = [];
  Object.keys(displayModules).map((resData, key) => {
    //console.log("displayModulesndfvbfjS",displayModules[resData])
    var tmpData = {
      firstparent: parent,
      id: resData,
      text: resData,
      // state: "closed",
      closed: false,
      children: getThirdLevelData(displayModules[resData], parent),
    };
    finalData.push(tmpData);
  });
  //console.log("finalData",finalData)
  return finalData;
}

function getThirdLevelData(module, parent) {
  var str = module;
  var permissions = module;
  //var permissions = ["create", "update", "delete", "cancel", "view"];
  var finalData = [];
  for (var i = 0; i < permissions.length; i++) {
    var tmpData = {
      firstparent: parent,
      id: permissions[i],
      text: permissions[i],
      closed: false,
    };
    finalData.push(tmpData);
  }
  return finalData;
}
